import { StepperContextData } from '../contexts';
import { getCookie, isAmazonHost } from '../utils';
import { environment } from '../utils/environment';

export const isMultidoor = (stepperData: StepperContextData) => {
  const { isParallel, multiDoor } = stepperData;
  return !!multiDoor && !isParallel;
};

type CountryCode = string | undefined;

export const getMarketplaceCountry = () => {
  const validateCode = (code: CountryCode): CountryCode => {
    return code?.length === 2 ? code : undefined;
  };

  let countryCode = isAmazonHost()
    ? // check language first, then as a fallback www.amazon.fr -> ['www', 'amazon', 'fr'] -> fr
      environment.locale?.split(/[_-]/)?.at(-1) ||
      window.location.hostname.split('.')?.at(-1)
    : getCookie('chosen_country');

  if (!validateCode(countryCode)) {
    const navigatorCode = navigator.language?.split(/[_-]/)?.at(-1);
    countryCode = validateCode(navigatorCode);
  }

  return countryCode?.toUpperCase() ?? '';
};
